import { useQuery } from "@tanstack/react-query";
import { riskReviewKeys } from "../constants/riskReviewQueryKeys";
import riskReviewService from "../services/riskReviewService";

export const useRiskReviewTemplates = (filters) =>
  useQuery({
    queryKey: riskReviewKeys.templateList(filters),
    queryFn: () => riskReviewService.getTemplates(filters),
    staleTime: 60000,
  });

export const useRiskReviewTemplate = (id) =>
  useQuery({
    queryKey: riskReviewKeys.template(id),
    queryFn: () => riskReviewService.getTemplate(id),
    enabled: Boolean(id),
    staleTime: 60000,
  });
